import React from 'react';
import { Card } from '@/components/ui/card';
import { TrendingUp, TrendingDown, CheckCircle, DollarSign, Construction } from 'lucide-react';

const fmt = (v) => `$${new Intl.NumberFormat('es-CL').format(v || 0)}`;

/**
 * Tab Flujo de Caja: KPIs financieros derivados de `presupuesto`.
 */
const FlujoCajaTab = ({ presupuesto }) => (
  <div className='space-y-6'>
    <div className='flex items-center justify-between'>
      <div>
        <h3 className='text-xl font-semibold text-slate-900 flex items-center gap-2'>
          <TrendingUp className='w-5 h-5 text-primary' />
          Flujo de Caja
        </h3>
        <p className='text-sm text-slate-500'>
          Resumen financiero y proyecciones de liquidez
        </p>
      </div>
    </div>

    {presupuesto && (
      <div className='grid grid-cols-1 md:grid-cols-4 gap-6'>
        <Card className='p-6 border-slate-200 bg-gradient-to-br from-green-50 to-emerald-50 border-green-200'>
          <div className='flex items-center gap-2 mb-2'>
            <TrendingUp className='w-5 h-5 text-green-600' />
            <span className='text-sm font-medium text-green-700'>Ingresos Proyectados</span>
          </div>
          <p className='text-2xl font-bold text-green-800'>{fmt(presupuesto.ingresos_proyectados)}</p>
        </Card>

        <Card className='p-6 border-slate-200 bg-gradient-to-br from-blue-50 to-cyan-50 border-blue-200'>
          <div className='flex items-center gap-2 mb-2'>
            <CheckCircle className='w-5 h-5 text-blue-600' />
            <span className='text-sm font-medium text-blue-700'>Ingresos Reales</span>
          </div>
          <p className='text-2xl font-bold text-blue-800'>{fmt(presupuesto.ingresos_reales)}</p>
        </Card>

        <Card className='p-6 border-slate-200 bg-gradient-to-br from-red-50 to-rose-50 border-red-200'>
          <div className='flex items-center gap-2 mb-2'>
            <TrendingDown className='w-5 h-5 text-red-600' />
            <span className='text-sm font-medium text-red-700'>Gastos Totales</span>
          </div>
          <p className='text-2xl font-bold text-red-800'>{fmt(presupuesto.gastos_totales)}</p>
        </Card>

        <Card className={`p-6 border-slate-200 ${presupuesto.balance >= 0
          ? 'bg-gradient-to-br from-emerald-100 to-green-100 border-emerald-300'
          : 'bg-gradient-to-br from-red-100 to-rose-100 border-red-300'}`}>
          <div className='flex items-center gap-2 mb-2'>
            <DollarSign className={`w-5 h-5 ${presupuesto.balance >= 0 ? 'text-emerald-600' : 'text-red-600'}`} />
            <span className={`text-sm font-medium ${presupuesto.balance >= 0 ? 'text-emerald-700' : 'text-red-700'}`}>Balance</span>
          </div>
          <p className={`text-2xl font-bold ${presupuesto.balance >= 0 ? 'text-emerald-800' : 'text-red-800'}`}>
            {fmt(presupuesto.balance)}
          </p>
        </Card>
      </div>
    )}

    <Card className='p-8 text-center border-slate-200 border-dashed bg-slate-50'>
      <Construction className='w-12 h-12 text-slate-400 mx-auto mb-3' />
      <h4 className='text-lg font-semibold text-slate-600 mb-2'>Proyecciones en Desarrollo</h4>
      <p className='text-slate-500 max-w-md mx-auto text-sm'>
        Próximamente: Gráficos de tendencias, proyecciones de ingresos y egresos, alertas de liquidez y planificación financiera.
      </p>
    </Card>
  </div>
);

export default FlujoCajaTab;
